export default function TermsOfService() {
  return (
    <div className="max-w-4xl mx-auto px-6 py-16">
      <h1 className="text-4xl font-bold text-gray-900 mb-8">Terms of Service</h1>
      
      <div className="space-y-6 text-gray-700">
        <section>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Agreement to Terms</h2>
          <p className="mb-4">
            By accessing and using our auto transport services, you agree to be bound by these 
            Terms of Service and all applicable laws and regulations.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Service Description</h2>
          <p className="mb-4">
            We provide vehicle transportation services across the United States. All quotes 
            are estimates and final pricing may vary based on vehicle condition, accessibility, 
            and other factors.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">User Responsibilities</h2>
          <p className="mb-4">You agree to:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Provide accurate information about your vehicle and transport needs</li>
            <li>Ensure your vehicle is in operable condition unless otherwise specified</li>
            <li>Remove all personal items from the vehicle before transport</li>
            <li>Be available at pickup and delivery locations at scheduled times</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Payment Terms</h2>
          <p className="mb-4">
            Payment terms will be specified in your transport agreement. A deposit may be 
            required to secure your booking, with the balance due upon delivery.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Cancellation Policy</h2>
          <p className="mb-4">
            Cancellations must be made in writing. Cancellation fees may apply depending on 
            the timing of your cancellation relative to the scheduled pickup date.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Limitation of Liability</h2>
          <p className="mb-4">
            Our liability is limited to the terms specified in your transport agreement and 
            our insurance coverage. We are not liable for delays caused by weather, traffic, 
            or other circumstances beyond our control.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Contact Information</h2>
          <p className="mb-4">
            For questions about these Terms of Service, contact us at:
          </p>
          <p className="mb-2">
            <strong>Email:</strong> marcos.disla@shiplux.com
          </p>
          <p>
            <strong>Phone:</strong> (305) 871-9862
          </p>
        </section>

        <p className="text-sm text-gray-500 mt-8">
          Last updated: {new Date().toLocaleDateString()}
        </p>
      </div>
    </div>
  );
}
